import { useEffect, useState, useCallback } from 'react';
import { Link, useHistory } from 'react-router-dom';

import { DOCTOR_COLUMNS } from 'config/doctor';
import { getAllActiveDoctors } from 'api/doctors';

import Table from 'components/table/table';
import Loading from 'components/loading/loading';

const Doctors = () => {
  const [fetching, setFetching] = useState(true);
  const [doctors, setDoctors] = useState([]);
  const [meta, setMeta] = useState({});

  const history = useHistory();

  const getData = useCallback(async (page) => {
    setFetching(true);
    const data = await getAllActiveDoctors(page);
    setDoctors(data.items);
    setMeta(data.meta);
    setFetching(false);
  }, []);

  useEffect(() => {
    (async () => {
      await getData();
    })();
  }, [getData]);

  if (fetching) return <Loading />;

  return (
    <main className="th-main">
      <section className="th-canvas">
        <header className="th-canvas-header post-header members-header">
          <h2 className="th-canvas-title" data-test-screen-title>
            <Link to="/doctors" className="active">
              Doctors
            </Link>
          </h2>

          <section className="view-actions">
            <button
              className="btn-green"
              data-cy="submit"
              onClick={() => history.push('/doctors/add')}
            >
              Add doctor
            </button>
          </section>
        </header>
        <section className="view-container">
          <Table
            columns={DOCTOR_COLUMNS}
            data={doctors}
            meta={meta}
            hasViewBar
            fetching={fetching}
            fetchData={(p) => getData(p)}
            isSearchable={false}
          />
        </section>
      </section>
    </main>
  );
};

export default Doctors;
